import { createApi } from "./api";

class LearnerService {
  constructor() {
    this.api = createApi("/learners");
  }

  getAllLearners() {
    return this.api.get(`/getAllLearners`);
  }

  getLearners(section) {
    return this.api.get(`/getLearners/${section}`);
  }

  getLearner(id) {
    return this.api.get(`/getLearner/${id}`);
  }

  deleteLearner(id) {
    return this.api.delete(`/deleteLearner/${id}`);
  }

  updateLearner(id, data) {
    return this.api.put(`/updateLearner/${id}`, { data });
  }

  newLearner(data) {
    return this.api.post(`/newLearner`, { data });
  }

  check(id, date, council = false) {
    return this.api.patch(`/check${council ? "Council" : ""}/${id}/${date}`);
  }

  uncheck(id, date, council = false) {
    return this.api.patch(`/uncheck${council ? "Council" : ""}/${id}/${date}`);
  }
}

const learnerService = new LearnerService();

export default learnerService;
